// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"ded78ae1","419":"d119ce52","563":"53a11686","942":"b0e71be5"}[chunkId] + ".chunk.js";
};